import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function IntroOverlay() {
    const [open, setOpen] = useState(true);

    const close = () => {
        setOpen(false);
        window.dispatchEvent(new Event("gala:start-music"));
    };

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    data-testid="intro-overlay"
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } }}
                    className="fixed inset-0 z-[100] bg-night-deep/95 backdrop-blur-xl flex items-center justify-center px-6 py-10 overflow-y-auto"
                >
                    <motion.div
                        initial={{ opacity: 0, y: 30, scale: 0.97 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
                        className="relative w-full max-w-3xl my-auto"
                    >
                        <div className="text-center mb-8">
                            <p className="text-[10px] sm:text-xs tracking-[0.45em] uppercase text-gold">Le verdict est tombé</p>
                            <p data-testid="intro-title" className="mt-3 font-display italic text-xl sm:text-3xl text-white leading-snug">
                                Oscar de la Meilleure Actrice :<br />
                                <span className="text-gold gold-glow not-italic font-semibold">Lavinia Cox</span>
                                <span className="text-white/70"> dans </span>
                                <span className="text-gold">Top Gun</span>
                            </p>
                        </div>

                        <div className="relative">
                            <div className="absolute -inset-3 border border-gold/30 translate-x-3 translate-y-3 pointer-events-none" />
                            <img
                                data-testid="intro-poster"
                                src="/images/intro-poster.webp"
                                alt="Lavinia Cox — affiche Top Gun"
                                className="relative w-full max-h-[52vh] object-contain border border-gold/20 bg-night"
                            />
                        </div>

                        <div className="mt-10 flex flex-col items-center gap-5">
                            <button
                                data-testid="intro-enter-button"
                                onClick={close}
                                className="group relative overflow-hidden border border-gold/60 px-10 py-4 text-xs tracking-[0.3em] uppercase text-gold transition-colors duration-500 hover:text-night-deep"
                            >
                                <span className="absolute inset-0 bg-gold translate-y-full transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:translate-y-0" />
                                <span className="relative">Revivre la soirée</span>
                            </button>
                            <p className="text-[10px] tracking-[0.3em] uppercase text-white/35">03 . 10 . 2026 · Le Piesmont, Lasne</p>
                        </div>

                        <button
                            data-testid="intro-close-button"
                            onClick={close}
                            aria-label="Fermer"
                            className="absolute -top-2 right-0 sm:-right-2 flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/60 transition-colors duration-400 hover:border-gold hover:text-gold"
                        >
                            <X size={16} strokeWidth={1.5} />
                        </button>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
